<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <v-row justify="space-between">
      <v-col>
        <h2>
          Uredite svoje podjetje:
        </h2>
      </v-col>
    </v-row>

    <ClientsFormEdit
      @save="save"
      @cancel="cancel"
      :client="myCompany"
      :isChildCompany="false"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import ClientsFormEdit from '@/components/ClientsFormEdit'

export default {
  components: {
    ClientsFormEdit
  },
  mixins: [
    asyncDataStatus
  ],
  computed: {
    myCompany () {
      return this.$store.state.companies.myCompany
    }
  },
  methods: {
    ...mapActions('companies', ['loadMyCompany', 'updateMyCompany']),
    save ({ data }) {
      this.updateMyCompany(data)
        .then(company => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
        })
    },
    cancel () {
      this.$router.push({ name: 'MyCompany' })
    }
  },
  created () {
    this.loadMyCompany()
      .then(myCompany => { this.asyncDataStatus_fetched() })
  }
}
</script>
